(function($) {

  /**
   * strToObject
   * @param {String} str
   * @param {String} separator1 separator between pair property/value
   * @param {Number} separator2 separator between property and value
   */
  function strToObject(str, separator1, separator2) {
    var a = str.split(separator1);
    var o = {};
    var i, temp;
  
    for (i = 0; i < a.length; i++) {
      temp = a[i].split(separator2);
      o[temp[0]] = temp[1];
    }
  
    return o;
  }

  /**
   * Set a new cookie
   * @param {String} cname Name of the cookie
   * @param {String} cvalue Value of the cookie
   * @param {Number} exdays Number of days until cookie should expire
   */
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();

    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  /**
   * Initialization
   */
  function init() {
    var $el = $('#combox');
    var cookies = strToObject(document.cookie, '; ', '=');
    var popupMsgDate = rhum_attitude.popup_msg_date;
    var lastDate = cookies.box_com_agree || 0;

    console.log('test', popupMsgDate, lastDate);

    if (popupMsgDate > lastDate) {
      $el
        .css('display', 'block')
        .find('.com-box__close').on('click', function() {
          setCookie('box_com_agree', popupMsgDate, '15');
          $el.remove();
        })
    }
  }

  jQuery(init);
})(jQuery)